<template>
  <div class="bdy_top_menua">
    <div class="table_list">
      <div class="table_list_button">
        <h1>菜单列表</h1>
      </div>
      <el-form>
        <el-form-item label="请选择门店">
          <el-select placeholder="请选择" v-model="shop_id" @change="getList">
            <el-option
              v-for="index in typeData"
              :key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        :fit="false"
        border
        :data="tableData"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="图片" width="180">
          <template slot-scope="scope">
            <img :src="scope.row.image " style="width:100px;height:100px"/>
          </template>
        </el-table-column>
        <el-table-column label="标签" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.labels">
              <span v-for="(item,index) in scope.row.labels" :key="index">{{ item }}/</span>
            </div>
          </template>
          
        </el-table-column>
        <el-table-column label="单位卡路里" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.calorie }}卡</span>
          </template>
        </el-table-column>
        <el-table-column label="脂肪" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.fat }}g</span>
          </template>
        </el-table-column>
        <el-table-column label="碳水化合物" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.carbohydrate }}g</span>
          </template>
        </el-table-column>
        <el-table-column label="蛋白质" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.protein }}g</span>
          </template>
        </el-table-column>
           <el-table-column label="价格" width="180">
          <template slot-scope="scope">
            <span v-for="item in scope.row.prices" :key="item.id">
              <div>价格:{{item.price/100}}元 {{item.amount}}{{item.name}}</div>
              <div>VIP价格:{{item.vip_price/100}}元 {{item.amount}}{{item.name}}</div>
            </span>
          </template>
        </el-table-column>
        
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  range as rangeArr,
  getFirstDayOfMonth,
  getPrevMonthLastDays,
  getMonthDays,
} from 'element-ui/src/utils/date-util';
import fecha from 'element-ui/src/utils/date';
import moment from 'moment';
export default {
  name: 'shop',
  components: {},
  data() {
    return {
      platform: '',
      formLabelWidth: '120px',
      tableData: [],
      value: 'shanghai',
      typeData: [],
      shop_id: '',
      // formInline: {},
    };
  },

  methods: {
    getList() {
      // user_menu_list
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_device_dish_platform
      } else {
        baseUrl = this.$userList.user_device_dish
      }
      const data = {
        cursor: '1',
        size: 10,
        shop_id: this.shop_id,
      };
      this.$http.post(baseUrl, data).then(res => {
        if (res.code === 200) {
          console.log(res.data.items);
          this.tableData = res.data.items;
        }
      });
    },
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.typeData = res.data.items;
          this.shop_id = res.data.items[0].id;
          console.log(this.shop_id);
          this.getList();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
  },

  created() {
    let platform = this.$route.query.platform
    console.log("platform is :", platform)
    this.platform = platform

    this.$root.setheadName();
    this.getType();
  },
};
</script>
<style scoped>
.bdy_top_menua {
  width: 100%;
  height: auto;
}

.rili {
  width: 100%;
  height: auto;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
  font-size: 14px;
}
.rili .ul {
  width: 100%;
  border-top: solid 1px #eee;
  display: flex;
  justify-content: space-between;
  border-left: solid 1px #eee;
}
.rili .ul li {
  flex: 1;
  border-right: solid 1px #eee;
  min-height: 77px;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 10px;
  padding-top: 30px;
}
.rili .ul li span {
  position: absolute;
  right: 10px;
  top: 5px;
}
.rili .ul:last-child li {
  border-bottom: solid 1px #eee;
}
.back_r {
  display: flex;
}
.back_r li {
  flex: 1;
  text-align: end;
}
.prev,
.next {
  color: #c0c4cc;
}
.clickDate {
  background: #f2f8fe;
  color: #409eff;
}
.ceshis {
  flex: 1;
  height: 20px;
  text-align: center;
}
.leftClass {
  box-sizing: border-box;
  margin-left: 10px;
  border-radius: 5px 0 0 5px;
}
.rightClass {
  box-sizing: border-box;
  margin-right: 10px;
  border-radius: 0 5px 5px 0;
}
.table_list {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.table_list_button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-table__body,
.el-table__header {
  width: 100% !important;
}
table,
tbody,
thead {
  width: 100% !important;
}
colgroup {
  position: absolute;
  width: 100% !important;
  display: flex;
}
col {
  flex: 1;
  text-align: center;
}
.clickPrevent {
  position: fixed;
  width: 50px;
  height: auto;
  background: #fff;
  text-align: center;
  box-sizing: border-box;
  padding: 20px 0;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
.topselect {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 40px;
}
.scope_a_class {
  display: flex;
  justify-content: space-between;
}
.scope_a_class > a {
  color: #409eff;
}
</style>
